var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Button, Table, TableCell, TableHead, TableRow } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { isEmpty, keys } from "ramda";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import uuid from "uuid";
import { IconButton } from "material-ui";
import { WebSocketMessage } from "../../serverConnection";
import CountrySelect from "../common/CountrySelect";
import InputField from "../common/InputField";
var validate = function (enterprise, existingNames) {
    var errors = {};
    if (isEmpty(enterprise.name)) {
        errors.name = "You must provide a value";
    }
    if (existingNames.includes(enterprise.name)) {
        errors.name = "Enterprise already exists";
    }
    if (enterprise.countries.length === 0) {
        errors.countries = "You must select at least one country";
    }
    if (enterprise.areas.length === 0) {
        errors.areas = "At least one area has to be defined for the enterprise";
    }
    return errors;
};
var NewEnterprise = function (props) {
    var current = props.enterprises.find(function (e) { return e.id === props.match.params.id; });
    var _a = useState(current || {
        id: uuid.v1(),
        name: "",
        countries: [],
        areas: [],
        invoicingParty: "",
        created: new Date(),
        updated: new Date(),
    }), enterprise = _a[0], setEnterprise = _a[1];
    var _b = useState({ country: enterprise.countries[0] || "DE", name: "" }), newArea = _b[0], setNewArea = _b[1];
    var updateEnterprise = function () {
        props.send(WebSocketMessage("enterprises", "update", enterprise));
        if (props.currentUser.role === "admin") {
            props.send(WebSocketMessage("users", "update", {
                id: props.currentUser.id,
                enterprises: __spreadArrays(props.currentUser.enterprises, [enterprise.id]),
            }));
        }
        props.history.push("/enterprises");
    };
    var errors = validate(enterprise, current ? [] : props.enterprises.map(function (e) { return e.name; }));
    if (!["su", "admin", "agent"].includes(props.currentUser.role)) {
        props.history.push("/users");
    }
    var IB = IconButton;
    return (React.createElement("div", { className: "container content" },
        React.createElement("div", { className: "container" },
            React.createElement("h5", null, "New Enterprise"),
            React.createElement("br", null),
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                } },
                React.createElement("div", { className: "card-panel" },
                    React.createElement(InputField, { label: "Enterprise", type: "text", placeholder: "", meta: {
                            touched: true,
                            error: errors.name,
                        }, onChange: function (name) { return setEnterprise(__assign(__assign({}, enterprise), { name: name })); }, value: enterprise.name, disabled: !["su", "admin"].includes(props.currentUser.role) }),
                    React.createElement(CountrySelect, { value: enterprise.countries, multiple: true, onChange: function (e) {
                            setEnterprise(__assign(__assign({}, enterprise), { countries: __spreadArrays(e.target.value) }));
                        }, enterprises: props.enterprises, disabled: !["su", "admin"].includes(props.currentUser.role) }),
                    enterprise.areas && (React.createElement(Table, null,
                        React.createElement(TableHead, null,
                            React.createElement(TableCell, null, "Area"),
                            React.createElement(TableCell, null, "Country"),
                            React.createElement(TableCell, null, "\u00A0")),
                        enterprise.areas.map(function (a, i) { return (React.createElement(TableRow, { key: a.name + a.country },
                            React.createElement(TableCell, null, a.name),
                            React.createElement(TableCell, null, a.country),
                            React.createElement(TableCell, null,
                                React.createElement(IB, { color: "danger", onClick: function () {
                                        var areas = enterprise.areas;
                                        areas.splice(i, 1);
                                        setEnterprise(__assign(__assign({}, enterprise), { areas: areas }));
                                    } },
                                    React.createElement(ClearIcon, null))))); })))),
                React.createElement("br", null),
                React.createElement("br", null),
                enterprise.countries.length > 0 && (React.createElement("div", { className: "card-panel" },
                    React.createElement(CountrySelect, { value: newArea.country, countries: enterprise.countries, onChange: function (e) { return setNewArea(__assign(__assign({}, newArea), { country: e.target.value })); }, enterprises: props.enterprises }),
                    React.createElement(InputField, { label: "Area", type: "text", placeholder: "", meta: {
                            touched: false,
                        }, onChange: function (name) { return setNewArea(__assign(__assign({}, newArea), { name: name })); }, value: newArea.name }),
                    React.createElement("br", null),
                    React.createElement(Button, { className: "teal btn-flat btn right white-text", disabled: isEmpty(newArea.name), onClick: function () {
                            var areas = __spreadArrays(enterprise.areas, [newArea]);
                            setEnterprise(__assign(__assign({}, enterprise), { areas: areas }));
                            setNewArea({ country: enterprise.countries[0], name: "" });
                        } }, "Add area"))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(Link, { to: "/enterprises", className: "white btn-flat left red-text" }, "Cancel"),
                React.createElement("button", { className: "teal btn-flat btn right white-text", onClick: function () { return updateEnterprise(); }, disabled: keys(errors).length > 0 },
                    current ? "Update " : "Create ",
                    "enterprise"),
                React.createElement("br", null),
                React.createElement("br", null))),
        ";"));
};
export default withRouter(NewEnterprise);



//////////////////
// WEBPACK FOOTER
// ./src/components/enterprises/NewEnterprise.tsx
// module id = 1305
// module chunks = 0